import type { ConversationListItem } from '@/entities/conversations';
import { apiClient } from '@/shared/api';
import type { SearchResult } from '../types';
import { search } from '../api';
import type {
  SearchConversationDownloadRequest,
  SearchConversationRequest,
  SearchConversationRunPipelineRequest,
  SearchConversationRunPipelineResponse,
} from './types';

export const searchConversations = async (
  request: Omit<SearchConversationRequest, 'entityType'>,
): Promise<SearchResult<ConversationListItem>> => {
  return search<ConversationListItem>({
    ...request,
    entityType: 'conversation',
  });
};

/**
 * Выгрузка найденных диалогов файлом через POST /search/query/download.
 * Тело — та же выборка, что и у поиска, плюс формат файла; постраничности нет.
 */
export const downloadConversationsSearch = async (
  request: Omit<SearchConversationDownloadRequest, 'entityType'>,
): Promise<Blob> => {
  const { data } = await apiClient.post<Blob>(
    '/search/query/download',
    { ...request, entityType: 'conversation' },
    { responseType: 'blob' },
  );
  return data;
};

/**
 * Массовый запуск обработки диалогов через POST /search/query/run-pipeline.
 * Тело — та же выборка, что и у поиска, плюс выбранный пайплайн; постраничности нет.
 */
export const runConversationsPipeline = async (
  request: Omit<SearchConversationRunPipelineRequest, 'entityType'>,
): Promise<SearchConversationRunPipelineResponse> => {
  const { data } = await apiClient.post<SearchConversationRunPipelineResponse>('/search/query/run-pipeline', {
    ...request,
    entityType: 'conversation',
  });
  return data;
};
